export default __webpack_public_path__ + "static/media/logo_hoya.2e457974.png";